<template>
  <el-form-item
    :key="form.key"
    :label="form.cname+':'"
    :prop="prop"
    :rules="rule">
    <el-select
      v-if="status === 'edit'"
      v-model="form.fieldValue"
      style="width: 100%"
      placeholder=""
      clearable="">
      <el-option
        v-for="sitem in list"
        :key="sitem.inspectReportId"
        :label="tradeType ===1 ? `报关单号:${sitem.declarationCode}` : `检测编号:${sitem.certNumber}` "
        :value="sitem.inspectReportId">
      </el-option>
    </el-select>
    <span v-else>{{ name }}</span>
  </el-form-item>
</template>

<script>
export default {
  name: 'InspectFormSelect',
  components: {},
  props: {
    item: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    prop: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'edit'
    },
    productId: [String, Number],
    vendorId: [String, Number],
    tradeType: [String, Number]
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    form: {
      get() {
        return this.item
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    name() {
      const names = this.list.filter(o => this.form.fieldValue === o.inspectReportId)
      return names.map(o => this.tradeType === 1 ? `报关单号:${o.declarationCode}` : `检测编号:${o.certNumber}`).join('，')
    },
    config() {
      return this.tradeType === 1 ? {
        productIds: [this.productId],
        vendorId: this.vendorId,
        tradeType: this.tradeType
      } : {
        vendorId: this.vendorId,
        tradeType: this.tradeType
      }
    },
    rule() {
      return [
        {
          required: this.form.mandatory,
          message: this.form.cname + '不能为空',
          trigger: 'change'
        }
      ]
    }
  },
  watch: {
    config: {
      handler(val) {
        if (val.vendorId && val.tradeType) {
          this.fetchList()
        }
      },
      deep: true,
      immediate: true
    }
    // ,
    // vendorId: {
    //   handler (val, oldVal) {
    //     if (val) {
    //       this.fetchList()
    //     }
    //   },
    //   immediate: true
    // }
  },
  methods: {
    fetchList() {
      this.$store.dispatch('inspect/getinspectreports', {
        payload: {
          pageNum: 1,
          pageSize: 1000,
          ...this.config
          // tradeType: this.tradeType,
          // vendorId: this.vendorId
        },
        success: (res) => {
          this.list = res.data.records.map(item => {
            item.certFile = item.certFile.split(',')[0]
            return item
          })
        },
        fail: () => { }
      })
    }
  }
}
</script>
